import * as yup from 'yup';

// const digitsOnly = (value) => /^\d+$/.test(value)
const letterssOnly = (value) => /^[a-zA-Z]+$/.test(value)
const departmentTypes = (value) => /^(scaffolding|insulation|production|administration)$/.test(value);
const incidentTypes = (value) => /^(incident|unsafe-situation|unsafe-action|possible-danger)$/.test(value);

export const VALIDATION_SCHEMA = yup.object().shape({
  name: yup.string()
    .test('letters-only', 'error.letters-only', letterssOnly)
    .min(3, 'error.min-3')
    .required('error.name'),
  surname: yup.string().min(4, 'error.min-4').required('error.surname'),
  department: yup.string().test('required-dropdown', 'error.department', departmentTypes),
  date: yup.string().required('error.date'),
  project: yup.string().required('error.project'),
  place: yup.string().required('error.place'),
  incident: yup.string().test('required-dropdown', 'error.incident', incidentTypes),
  description: yup.string().required('error.description'),
  cause: yup.string().required('error.cause'),
  actions: yup.string().required('error.actions'),
  photo: yup.array().min(1, 'error.photo'),
  reportEmail: yup.string().email('error.email')
});
